export default __webpack_public_path__ + "./image/59eecdb581b60d39ebedf53776bf36cf.png";